<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {mapGetters, mapActions, mapState} from "vuex";
import moment from "moment";
import axios from "axios";


/**
 * Advanced table component
 */
export default {
    page: {
        title: "Purchases Report",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Layout,
        // QrcodeVue,
        PageHeader,
    },
    data() {
        return {
            value: "https://example.com",
            size: 300,
            title: "Purchases Report",
            items: [
                {
                    text: "Home",
                    href: "#/",
                },
                {
                    text: "Purchases Report",
                    active: true,
                },
            ],
            totalRows: 1,

            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100, 200, 1000],
            filter: null,
            todoFilter: null,
            filterOn: [],
            todofilterOn: [],
            sortDesc: false,
            fields: [
                {
                    key: "index",
                    sortable: true,
                    label: "S/N",
                },
                {
                    key: "drug_name",
                    sortable: true,
                    label: "NAME",
                },
                {
                    key: "unit_price",
                    sortable: true,
                    label: "PRICE PER UNIT",
                },
                {
                    key: "quantity",
                    sortable: true,
                    label: "QUANTITY",
                },
                {
                    key: "total",
                    sortable: true,
                    label: "TOTAL",
                },
                {
                    key: "date",
                    sortable: true,
                    label: "PURCHASE DATE",
                }
            ],
            data: {
                dto: moment(new Date()).format("YYYY-MM-DD"),
                dfrom: "",
            },

            filterTitle: "",
            filteredReport: [],
        };
    },
    computed: {
        ...mapGetters("purchases", ["Purchases"]),
        ...mapState("purchases", ["purchases"]),
        ...mapGetters("auth", ["user_permissions"]),

        /**
         * Total no. of records
         */

        rows() {
            return this.filteredReport ? this.filteredReport.length : 1;
        },
    },
    watch: {
        purchases(newValue) {
            // eslint-disable-next-line no-console
            // console.log(newValue.length)
            if (newValue.length > 0) {
                this.assignData();
            }
        },
    },
    mounted() {
        // Set the initial number of items
        this.totalRows = this.filteredReport ? this.filteredReport.length : 1;
    },
    methods: {
        ...mapActions({
            FetchPurchases: "purchases/fetchPurchases",
        }),
        // COMMA SEPARATORS
        thousandSeprator(m) {
            if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
                return m
                    .toString()
                    .replace(/\D/g, "")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
                return m;
            }
        },
        /**
         * Search the table data with search input
         */
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        assignData() {
            this.filteredReport = this.Purchases;
            this.filterReport();
        },
        Excel_export() {
            axios
                .post("export_purchases", this.data, {
                    responseType: "arraybuffer",
                })
                .then((response) => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", "Purchases.xlsx");
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Purchases Downloaded successfully",
                        life: 6000,
                    });
                    this.spinner = false;
                })
                .catch(() => {
                    this.spinner = false;
                    this.$toast.add({
                        severity: "error",
                        summary: "Something wrong",
                        detail: "Purchases Download failed",
                        life: 6000,
                    });
                });
        },

        filterReport() {
            let date2 = this.data.dto;
            let date1 = this.data.dfrom;
            this.filteredReport = this.Purchases.filter((element) => {
                if (this.data.dfrom == "" && this.data.dto != "") {
                    return element.date <= date2;
                } else if (this.data.dfrom != "" && this.data.dto != "") {
                    this.filterTitle = "Purchases From " + this.data.dfrom + " To " + this.data.dto;
                    return element.date >= date1 && element.date <= date2;
                }
            });
        },
    },
    created() {
        this.FetchPurchases();
        this.assignData();
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div v-if="filterTitle">
                                <h4>
                                    <center>{{ filterTitle }}</center>
                                </h4>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label>From</label>
                                    <input
                                            @change="filterReport()"
                                            type="date"
                                            v-model="data.dfrom"
                                            class="form-control"
                                    />
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label>To</label>
                                    <input
                                            @change="filterReport()"
                                            type="date"
                                            v-model="data.dto"
                                            class="form-control"
                                    />
                                </div>
                            </div>
                            <div class="col-4"></div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <b-button class="mb-3" variant="primary" @click="Excel_export()"
                                ><i class="fa fa-download"></i>Export</b-button
                                >

                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                                class="form-select form-select-sm"
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    class="datatables"
                                    :items="filteredReport ? filteredReport : []"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    @filtered="onFiltered"
                            >
                                <template #cell(index)="data">
                                    {{ data.index + 1 }}
                                </template>
                                <template #cell(drug_name)="data">
                                    {{data.item.pharmacyitem.drug }}
                                </template>
                                <template #cell(total)="data">
                                    {{ thousandSeprator(data.item.unit_price*data.item.quantity) }}
                                </template>

                            </b-table>
                            <center>
                                <h3 v-if="!Purchases" class="text-primary">
                                    <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                                    Please wait...
                                </h3>
                            </center>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="rows"
                                                :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
